<template>
  <div class="container">
    <div
      class="maxView"
      :class="{ color1: bgColor == 1, color2: bgColor == 2 }"
    >
      <!-- <img src="../../assets/logo.png" @click="navTo('/')" class="left"> -->
      <div class="leftText" @click="navTo('/')">ACTYSERVICIOS SAS</div>
      <div class="right">
        <div class="nav" @click="navTo('/')">Inicio</div>
        <div class="nav" @click="navTo('/aboutUs')">Sobre nosotros</div>
        <div class="nav" @click="navTo('/doubt')">Ayuda</div>

        <!-- <div class="nav" @click="navTo('/contactUs')">Contacto</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "maxView",
  data() {
    return {
      bgColor: 1,
    };
  },
  watch: {
    $route(e) {
      if (["aboutUs", "doubt", "contactUs"].includes(e.name)) {
        this.bgColor = 2;
      } else {
        this.bgColor = 1;
      }
      console.log("路由变化", e.name);
      // 在这里执行你的逻辑
    },
  },
  methods: {
    navTo(url) {
      this.$router.push(url).catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 680px) {
  .container {
    height: 85px;
    width: 100%;

    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .maxView {
    max-width: 1080px;
    width: 100%;
    padding: 0 15px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      height: 36px;
      display: block;
      width: auto;
      cursor: pointer;
    }
    .leftText {
      font-weight: 700;

      font-size: 30px;
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .nav {
        cursor: pointer;
        font-weight: 700;
        margin-left: 30px;
      }
    }
  }
}

@media only screen and (max-width: 680px) {
  .container {
    height: 85px;

    width: 100%;

    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .maxView {
    padding: 0 10px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      height: 36px;
      display: block;
      width: auto;
      cursor: pointer;
    }
    .leftText {
      font-weight: 700;

      font-size: 15px;
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .nav {
        cursor: pointer;
        font-size: 12px;
        font-weight: 700;
        margin-left: 10px;
      }
    }
  }
}

.color1 {
  color: #3d3d3d;

  .nav:hover {
    color: #4e9b39;
  }
}
.color2 {
  color: #19191a;

  .nav:hover {
    color: #4e9b39;
  }
}
</style>
